export default "__VITE_ASSET__cdaad73b__"